import { trigger, state, style, transition, animate } from "@angular/animations";

// Animation for Dropdown 
export const dropdownAnim = trigger("dropdownAnim", [
  transition(":enter", [
    style({ opacity: 0, transform: "translateY(-10px)" }),
    animate(
      "400ms ease-out",
      style({ opacity: 1, transform: "translateY(0)" })
    ),
  ]),
  transition(":leave", [
    animate(
      "300ms ease-in",
      style({ opacity: 0, transform: "translateY(-10px)" })
    ),
  ]),
]);

// Animation for slide fade-in & fade-out 
export const fadeSlideInOut = trigger("fadeSlideInOut", [
  transition(":enter", [
    style({ opacity: 0, transform: "translateY(10px)" }),
    animate(
      "400ms ease-out",
      style({ opacity: 1, transform: "translateY(0)" })
    ),
  ]),
  transition(":leave", [
    animate(
      "300ms ease-in",
      style({ opacity: 0, transform: "translateY(10px)" })
    ),
  ]),
]);

// Animation for expand & collapse 
export const expandCollapseAnim = trigger("expandCollapseAnim", [
  transition(":enter", [
    style({ height: "0", opacity: 0, overflow: "hidden" }),
    animate("400ms ease-out", style({ height: "*", opacity: 1 })),
  ]),
  transition(":leave", [
    animate("300ms ease-in", style({ height: "0", opacity: 0 })),
  ]),
]);

// Animation for the tree-editor add-relative wheel (scale + fade in/out)
export const wheelExpandAnim = trigger("wheelExpandAnim", [
  transition(":enter", [
    style({ opacity: 0, transform: "scale(0.3)" }),
    animate("220ms ease", style({ opacity: 1, transform: "scale(1)" })),
  ]),
  transition(":leave", [
    animate("220ms ease", style({ opacity: 0, transform: "scale(0.3)" })),
  ]),
]);

// Animation for the wheel's dimming backdrop overlay
export const wheelBackdropAnim = trigger("wheelBackdropAnim", [
  transition(":enter", [
    style({ opacity: 0 }),
    animate("220ms ease", style({ opacity: 0.5 })),
  ]),
  transition(":leave", [
    animate("220ms ease", style({ opacity: 0 })),
  ]),
]);

// Animation for description content fading
export const descriptionContentAnim = trigger("descriptionContentAnim", [
  state("enter", style({ opacity: 1, transform: "translateY(0)" })),
  state("leave", style({ opacity: 0, transform: "translateY(10px)" })),
  transition("enter => leave", [animate("300ms ease-in")]),
  transition("leave => enter", [animate("400ms ease-out")]),
]);
